import type { FC } from "react";

import { Select, type SelectProps } from "../Select/Select";
import type { SelectListOption } from "../SelectList/SelectList";

export type YearFieldProps = Omit<SelectProps, "options">;

/**
 * YearField component is a select component that contains years from 1900 to 2100.
 */
export const YearField: FC<YearFieldProps> = ({ ref, ...props }) => {
  const startYear = 1900;
  const endYear = 2100;

  const years = Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => startYear + i,
  );

  const options: SelectListOption[] = years.map((year) => ({
    value: year,
    label: year.toString(),
  }));

  return <Select ref={ref} options={options} {...props} />;
};
